<script>
  export default {
    name: 'screen-group-schedule-modal',

    data () {
      return {
        schedule: {}
      }
    },

    methods: {
      handleOk (e) {
        e.preventDefault()

        this.$store.dispatch('screenGroups/scheduleGroup', this.schedule).then(() => {
          this.$refs.modal.hide()
          this.schedule = {}
        }).catch((err) => {
          console.log('Unable to save screen group schedule', err)
        })
      }
    },

    created () {
      this.$emit('update:title', 'Edit Screen Group Schedule')
      this.$emit('update:ok-title', 'Save & Continue')
    }
  }
</script>

<template>
  <b-card-body>
  </b-card-body>
</template>
